<template lang="pug">
  b-navbar.header-lower-navbar
    b-nav.sticky-top(:is-navbar="true")
      template(v-for="menuItem in menuItems" v-if="checkItemVissibility(menuItem)")
        b-nav-item-dropdown(v-if="menuItem.subMenu" :key="menuItem.key" :text="$t(menuItem.text)")
          template(v-for="submenuItem in menuItem.subMenu" v-if="checkItemVissibility(submenuItem)")
            template(v-if="isSamePath(submenuItem.path)")
              b-dropdown-item(:key="submenuItem.key" @click="$emit('refresh')") {{ $t(submenuItem.text) }}
            template(v-else)
              b-dropdown-item(:key="submenuItem.key" :to="submenuItem.path") {{ $t(submenuItem.text) }}
        template(v-else)
          template(v-if="isSamePath(menuItem.path)")
            b-nav-item(@click="$emit('refresh')") {{ $t(menuItem.text) }}
          template(v-else)
            template(v-if="menuItem.externalPath")
              b-nav-item(:href="menuItem.externalPath+'/'+sessionToken" :target="menuItem.target || '_self'") {{$t(menuItem.text)}}
            template(v-else)
              b-nav-item(:to="menuItem.path" :target="menuItem.target || '_self'") {{$t(menuItem.text)}}
</template>

<script>
  import topMenuItems from '@/utils/topMenuItems'
  import session from '@/auth/session'
  import { getUserSubscription } from '@/utils/tokenUtils'

  export default {
    name: 'TopMenu',
    data () {
      return {
        menuItems: topMenuItems,
        sessionToken: session.getToken()
      }
    },
    methods: {
      isSamePath(path) {
        return this.$route.path === path
      },
      checkItemVissibility(item) {
        return item.active && (!item.userRoleAllowed || item.userRoleAllowed.includes(session.getUserRole())) && (!item.userSubscriptionAllowed || item.userSubscriptionAllowed.includes(getUserSubscription()))
      }
    },
    mounted () {
    }
  }
</script>
